module.exports = __webpack_public_path__ + "static/HelveticaNeue-a035ad376fc36ca17d91308451b8d015.ttf";